"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialogMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Dialog = require("../../components/Dialog/Dialog.styles");
var _DialogBody = require("../../components/DialogBody/DialogBody.styles");
var _DialogClose = require("../../components/DialogClose/DialogClose.styles");
var _DialogFooter = require("../../components/DialogFooter/DialogFooter.styles");
var _DialogHeader = require("../../components/DialogHeader/DialogHeader.styles");
var _DialogLayout = require("../../components/DialogLayout/DialogLayout.styles");
var _Mask = require("../../components/Mask/Mask.styles");
var _Text = require("../../components/Text/Text.styles");
var _constants = require("../../constants");
var _animationFadeInMixin = require("../animationFadeInMixin");
var _animationZoomInMixin = require("../animationZoomInMixin");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _overflowAutoMixin = require("../overflowAutoMixin");
var _overflowPaddingMixin = require("../overflowPaddingMixin");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
var _DialogMixin = require("./DialogMixin");
var _ModalMixin = require("./ModalMixin");
var fullScreenCSS = function fullScreenCSS(props) {
  return (0, _styledToken.default)({
    borderRadius: 'ModalDialog.borderRadius',
    paddingVertical: 'Modal.viewportPaddingVertical',
    paddingHorizontal: 'Modal.viewportPaddingHorizontal',
    fullScreenBorderRadius: 'ModalDialog.fullscreen.borderRadius'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      paddingVertical = _ref.paddingVertical,
      paddingHorizontal = _ref.paddingHorizontal,
      _ref$fullScreenBorder = _ref.fullScreenBorderRadius,
      fullScreenBorderRadius = _ref$fullScreenBorder === void 0 ? 0 : _ref$fullScreenBorder;
    // In order to support backwards compatibility and `mediaQuery` prop, we have to set
    // and reset CSS based on full screen size. We can remove the else condition once
    // `mediaQuery` prop is removed and unsupported.
    if (props.size === _constants.MODAL_SIZES.FULL_SCREEN) {
      return (0, _styledComponents.css)(["padding:0;> ", "{border-radius:", ";min-height:100%;}", "{opacity:0;}"], _Dialog.StyledDialog, fullScreenBorderRadius, _Mask.StyledMask);
    }
    return (0, _styledComponents.css)(["padding:", "px ", "px;> ", "{border-radius:", "px;min-height:0;}", "{opacity:1;}"], paddingVertical, paddingHorizontal, _Dialog.StyledDialog, borderRadius, _Mask.StyledMask);
  })(props);
};
var sizeCSS = function sizeCSS(props) {
  return (0, _styledToken.default)("ModalDialog.sizes." + props.size, function (size) {
    return (0, _styledComponents.css)(["", " > ", "{max-width:", ";}"], fullScreenCSS(props), _Dialog.StyledDialog, props.size === _constants.MODAL_SIZES.FULL_SCREEN ? size + "%" : size + "px");
  })(props);
};
var scrollCSS = function scrollCSS(_ref2) {
  var scrollDocument = _ref2.scrollDocument;
  if (scrollDocument) {
    return "align-items: start;";
  }
  return (0, _styledComponents.css)(["> ", "{max-height:100%;_:-ms-fullscreen &,&{height:100%;}}"], _Dialog.StyledDialog);
};

/** @class ModalDialogMixin */
/** @method */
var ModalDialogMixin = function ModalDialogMixin(props) {
  return (0, _styledToken.default)({
    dividerColor: 'ModalDialog.separatorColor',
    dividerWidth: 'ModalDialog.separatorWidth',
    fontType: 'Dialog.headingFontType',
    spacing: 'ModalDialog.padding'
  }, function (_ref3) {
    var dividerColor = _ref3.dividerColor,
      _ref3$dividerWidth = _ref3.dividerWidth,
      dividerWidth = _ref3$dividerWidth === void 0 ? 1 : _ref3$dividerWidth,
      fontType = _ref3.fontType,
      spacing = _ref3.spacing;
    return (0, _styledComponents.css)(["", " ", " > ", "{", " ", " display:flex;flex-direction:column;height:auto;min-height:0;width:100%;", "{display:flex;flex:1;flex-direction:column;min-height:100%;}", "{border-bottom:", ";flex:0 0 auto;padding:", "px calc(", "px + ", ");text-align:center;", "{", "}}", "{", " ", ";flex:1 1 auto;margin-top:", ";}", "{border-top:", ";flex:0 0 auto;display:flex;justify-content:flex-end;padding:", "px;}", "{top:", "px;right:", "px;}}", "{opacity:1;}", " ", ""], (0, _ModalMixin.ModalMixin)(props), (0, _animationFadeInMixin.animationFadeInMixin)(props), _Dialog.StyledDialog, (0, _DialogMixin.DialogMixin)(props), (0, _animationZoomInMixin.animationZoomInMixin)(props), _DialogLayout.StyledDialogLayout, _DialogHeader.StyledDialogHeader, props.dividers ? dividerWidth + "px solid " + dividerColor : 'none', spacing, spacing, (0, _spaceMixin.spaceMixin)('lg')(props), _Text.StyledText, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), _DialogBody.StyledDialogBody, (0, _overflowAutoMixin.overflowAutoMixin)(props), (0, _overflowPaddingMixin.overflowPaddingMixin)(spacing + "px", spacing + "px", spacing + "px"), props.renderHeader || props.header ? '0' : (0, _spaceMixin.spaceMixin)(4)(props), _DialogFooter.StyledDialogFooter, props.dividers ? dividerWidth + "px solid " + dividerColor : 'none', spacing, _DialogClose.StyledDialogClose, spacing, spacing, _Mask.StyledMask, scrollCSS(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('size', sizeCSS)(props));
  })(props);
};
exports.ModalDialogMixin = ModalDialogMixin;